import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import PropTypes from "prop-types";

import dataBank from "common/data/bank_country_noselect.json";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import BankingTable from "components/molecules/BankingTable";
import { BankMobile } from "components/organisms/BankingOptions";
import Banner from "components/organisms/Banner";
import OnlineBankingTool from "components/organisms/OnlineBankingTool";
import PackageAndFee from "components/organisms/PackageAndFee";
import RequiredDocument from "components/organisms/RequiredDocument";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const traditionalThead = [
  "Country",
  "Bank",
  "Online Banking",
  "Personal Visit",
  "Credit Card",
  "Debit Card",
  "Initial Deposit",
];

const VNOpenBankAccountTemplate = ({ data, dataJson }) => {
  const { country, breadcrumbs, dataHowToOpen, dataOpenBankFee } = dataJson;

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={breadcrumbs}
        title={`Bank Account Opening For ${country} Company`}
        titleProps={{
          className: "banner-default-title mb-10",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={
              dataJson?.imgBanner
                ? dataJson?.imgBanner
                : "/assets/images/common/open-bank.png"
            }
            className="w-full "
            wrapper={{
              className: "bbc-banner-image-country pb-10 lg:pb-0 ",
            }}
            width={591}
            height={412}
            priority={true}
            alt="bank account opening service in Vietnam"
          />
        }
        bgColor={"bg-bbc-country"}
      />

      <section>
        <div className="container">
          <Title
            text={dataHowToOpen.title}
            className="bbc-title mt-10 mb-10 text-center capitalize lg:mt-20"
          />
          <div
            className={`paragraph ${
              country.toLowerCase() === "singapore" && "blue-marker"
            }`}
          >
            {dataHowToOpen.content.map((item, index) => (
              <div key={index} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
          {dataHowToOpen.note ? (
            <div dangerouslySetInnerHTML={{ __html: dataHowToOpen.note }}></div>
          ) : (
            <>
              <p className=" mt-4 border-l-4 border-bbc-brand-700 pl-2 font-medium">
                Wonder which can be the best bank for your {country} company?
                Let&apos;s find out with our{" "}
                <LinkRouter
                  href="/guide-and-tool/banking-tool"
                  target="_blank"
                  className="text-bbc-brand-500"
                >
                  Banking Tool
                </LinkRouter>
              </p>
            </>
          )}
        </div>
      </section>
      {dataJson.dataOnlineBankingTool &&
        typeof dataJson.dataOnlineBankingTool === "object" &&
        Object.keys(dataJson.dataOnlineBankingTool).length > 0 && (
          <section>
            <OnlineBankingTool data={dataJson.dataOnlineBankingTool} />
          </section>
        )}
      {dataOpenBankFee &&
        Object.keys(dataOpenBankFee).length > 0 &&
        dataOpenBankFee.dataBankingPackage.length > 0 && (
          <section className="pb-10 lg:pb-20">
            <PackageAndFee
              data={dataOpenBankFee}
              country={country}
              title={dataOpenBankFee.title}
            />
          </section>
        )}
      <section className="container">
        <Title className="my-6 pb-0 text-center text-2xl font-semibold leading-[44px] text-bbc-brand-800 md:my-8 md:text-3xl">
          Banking Options for Vietnam Company
        </Title>
        <div className="hidden md:block">
          <BankingTable
            data={dataBank.vietnam}
            className="mt-4"
            thead={traditionalThead}
          />
        </div>
        <div className="mt-6 block md:hidden ">
          <BankMobile data={dataBank.vietnam} thead={traditionalThead} />
        </div>
      </section>
      <section>
        <RequiredDocument
          title={dataJson.dataRequiredDocument.title || "Required Documents"}
          data={dataJson.dataRequiredDocument}
          sectionClassName="py-10 lg:py-20"
          backgroundImage="/assets/images/common/required-documents.png"
        />
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default VNOpenBankAccountTemplate;

VNOpenBankAccountTemplate.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

VNOpenBankAccountTemplate.defaultProps = {
  data: {},
  posts: [],
};
